<template>
    <slot name="filter_category" v-bind="this"></slot>
</template>

<script>
export default {
    props: {
        category: null
    },
    data() {
        return {
            isOpen: !this.category.collapsed
        }
    },
    methods: {
        toggleArrow() {
            this.isOpen = !this.isOpen;
        },
        handleOptionUpdate(updatedFilter) {

            this.category.filters.forEach((filter, idx) => {
                if (filter.name === updatedFilter.name) {
                    if (updatedFilter.currentMin !== undefined || updatedFilter.currentMax !== undefined) {
                        if (filter.type === 'range' && Array.isArray(filter.options)) {
                            const newOptions = filter.options.map((option, i) => {
                                if (i === 0) {
                                    return { ...option, value: updatedFilter.currentMin };
                                } else if (i === 1) {
                                    return { ...option, value: updatedFilter.currentMax };
                                }
                                return option;
                            });
                            this.category.filters[idx] = { ...filter, options: newOptions };
                        }
                    } else {

                        this.category.filters[idx] = { ...filter, ...updatedFilter };
                    }
                }
            });

            this.$emit('update-category', this.category);
        },

        getCollapseClass(collapsed) {
            return collapsed ? 'collapse' : 'collapse show';
        }
    },
};
</script>
